import { type MouseEvent } from 'react'
import {
  type CtaAction,
  type CtaProduct,
  type HeroCta,
} from './multiProductHomePage.consts'

type OnCtaClick = (
  event: MouseEvent<HTMLElement>,
  opts: {
    url: string
    action: CtaAction
    product: CtaProduct
    requireQuiz?: boolean
  }
) => void

type HeroCtaLabels = {
  learnMore: string
  shopNow: string
  continueDesigning: string
}

export function buildHeroCtas({
  product,
  learnMoreUrl,
  buyUrl,
  isWorkInProgress,
  labels,
  onCtaClick,
}: {
  product: CtaProduct
  learnMoreUrl: string
  buyUrl: string
  isWorkInProgress: boolean
  labels: HeroCtaLabels
  onCtaClick: OnCtaClick
}): HeroCta[] {
  const learnMore: HeroCta = {
    id: 'learn-more',
    label: labels.learnMore,
    to: learnMoreUrl,
    variant: 'primary',
    onClick: (e: MouseEvent<HTMLElement>) =>
      onCtaClick(e, { url: learnMoreUrl, action: 'Learn More', product }),
  }

  const buy: HeroCta = {
    id: 'buy',
    label: isWorkInProgress ? labels.continueDesigning : labels.shopNow,
    to: buyUrl,
    variant: 'glass',
    onClick: (e: MouseEvent<HTMLElement>) =>
      onCtaClick(e, {
        url: buyUrl,
        action: isWorkInProgress ? 'Continue Design' : 'Buy',
        product,
        requireQuiz: !isWorkInProgress,
      }),
  }

  return [learnMore, buy]
}
